import { Modal } from 'ant-design-vue'
import { reactive, ref } from 'vue'
import { apiRoutes } from '../infraestructure/apiRoutes'
import { buildQueryParameters, get, post, softDelete, update } from '../infraestructure/repository/generic.repository'


const normalizeType = (t) => {
  if (t === 'Notas') return 'Nota';
  return t;
};

const useConsignmentSetting = () => {

  // ****************************************************************
  // ****************************************************************
  // VARIABLES INITIALIZATION

  // Paginator constants
  let paginatorTotalItems = ref(0)
  let paginatorTotalPages = ref(0)
  let paginatorCurrentPage = ref(0)

  const searchText = ref('')
  const visible = ref(false)

  const formId = ref('')
  let form = reactive({
    order: 1,
    name: '',
    type: 'Recomendación',
    activeRecord: true,
    status: true,
  })
  let formLoad = ref(false)
  const rules = {
    order: [
      { required: true, message: 'El orden es obligatorio' },
      { validator: (_, v) => (Number(v) >= 1 ? Promise.resolve() : Promise.reject('El orden debe ser ≥ 1')) },
    ],
    name: [{ required: true, message: 'El nombre de leyenda es obligatorio' }],
    type: [{ required: true, message: 'El tipo es obligatorio' }],
  }

  // ERROR VARIABLES
  let errorHandler = reactive({
    errorDescription: {
      errors: [],
    },
    errorNumber: 0,
  })
  const ruleForm = ref(null)

  const consignmentSettings = ref([])
  const tableLoading = ref(false)
  // VARIABLES INITIALIZATION
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // MODAL FUNCTIONS
  const openModal = (data = null) => {
    tableLoading.value = true
    visible.value = true
    if (formId.value !== '' && data) {
      const { order, name, type, activeRecord, status } = data
      form.order = order
      form.name = name
      form.type = type
      form.activeRecord = activeRecord
      form.status = status
    }
    tableLoading.value = false
  }
  const closeModal = () => {
    visible.value = false
    reinitializeForm()
  }
  const reinitializeForm = () => {
    formId.value = ''
    form.order = 1
    form.name = ''
    form.type = 'Recomendación'
    form.activeRecord = true
    form.status = true

    errorHandler.errorDescription.errors = []
    errorHandler.errorNumber = 0
  }
  // MODAL FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  // ****************************************************************
  // ****************************************************************
  // EVENTS FUNCTIONS
  const eventOpenModal = (data) => {
    const { id } = data
    formId.value = id
    openModal(data)
  }

  const eventSoftDelete = (data) => {
    Modal.confirm({
      title: '¿Está seguro de eliminar este registro?',
      content: 'Está operación será irreversible, elija con precaución.',
      okText: 'Si, eliminar',
      okType: 'danger',
      cancelText: 'No',
      async onOk() {
        tableLoading.value = true

        const { id } = data
        formId.value = id
        await deleteRecord()
      },
      onCancel() {
      },
    })
  }
  // EVENTS FUNCTIONS
  // ****************************************************************
  // ****************************************************************

  const onChangePaginator = async (current) => {
    await getConsignmentSettings(10, current)
  }

  const getConsignmentSettings = async (limit = 10, page = 0) => {
    tableLoading.value = true

    const path = `${apiRoutes.consignmentSetting}${buildQueryParameters(searchText, limit, page)}`
    const response = await get(path)
    const { items, total, totalPages, currentPage } = response.data

    consignmentSettings.value = items
    paginatorTotalItems.value = total
    paginatorTotalPages.value = totalPages
    paginatorCurrentPage.value = (currentPage + 1)

    tableLoading.value = false
  }
  getConsignmentSettings(10, 0)

  const submit = async () => {
    formLoad.value = true
    const path = apiRoutes.consignmentSetting

    if (formId.value !== '') {

      // Update

      const payload = {
        order: Number(form.order),
        name: form.name,
        type: normalizeType(form.type),
        activeRecord: form.activeRecord,
        status: form.status,
      };

      await update(path, formId.value, payload).then(() => {

        Modal.success({
          title: `¡El registro se ha actualizado exitosamente!`,
        })
        closeModal()
        formLoad.value = false

      }).catch((error) => {
        const res = error?.response;
        const data = res?.data;
        let msgs = [];

        if (error?.message && !res) {
          msgs = [String(error.message)];
        } else if (Array.isArray(data?.message)) {
          msgs = data.message.map(m => String(m)).filter(Boolean);
        } else if (typeof data?.message === 'string') {
          msgs = [data.message];
        } else if (typeof data === 'string') {
          msgs = [data];
        }

        if (!msgs.length) {
          const raw = error?.message || 'Ocurrió un error al actualizar la leyenda.';
          msgs = [raw];
        }

        errorHandler.errorDescription.errors = msgs;
        errorHandler.errorNumber = data?.statusCode || res?.status || 0;
        formLoad.value = false;

      })


    } else {

      // Create

      const payload = {
        order: Number(form.order),
        name: form.name,
        type: normalizeType(form.type),
        activeRecord: form.activeRecord,
        status: form.status,
      };

      await post(path, payload).then(() => {

        Modal.success({
          title: `¡El registro se ha almacenado exitosamente!`,
        })
        closeModal()
        formLoad.value = false

      }).catch((error) => {
        const res = error?.response;
        const data = res?.data;
        let msgs = [];

        if (error?.message && !res) {
          msgs = [String(error.message)];
        } else if (Array.isArray(data?.message)) {
          msgs = data.message.map(m => String(m)).filter(Boolean);
        } else if (typeof data?.message === 'string') {
          msgs = [data.message];
        } else if (typeof data === 'string') {
          msgs = [data];
        }

        if (!msgs.length) {
          const raw = error?.message || 'Ocurrió un error al actualizar la leyenda.';
          msgs = [raw];
        }

        errorHandler.errorDescription.errors = msgs;
        errorHandler.errorNumber = data?.statusCode || res?.status || 0;
        formLoad.value = false;
      })
    }

    await getConsignmentSettings(10, 0)
  }

  const deleteRecord = async () => {

    const path = apiRoutes.consignmentSetting
    const response = await softDelete(path, formId.value)
    if (response) {
      formId.value = ''
      await getConsignmentSettings(10, 0)
    }

  }

  return {
    searchText,
    visible,
    formId,
    form,
    formLoad,
    rules,
    consignmentSettings,
    tableLoading,
    errorHandler,
    ruleForm,

    paginatorTotalItems,
    paginatorTotalPages,
    paginatorCurrentPage,
    onChangePaginator,

    openModal,
    closeModal,
    getConsignmentSettings,
    submit,
    deleteRecord,

    eventOpenModal,
    eventSoftDelete,
  }
}

export default useConsignmentSetting

